import html2canvas from 'html2canvas'

interface PrintConfig {
  name: string
  querySelector: string
}

export async function printscreen(config: PrintConfig) {
  try {
    const element = document.querySelector(config.querySelector) as HTMLElement

    if (!element) {
      throw new Error('Elemento não encontrado')
    }

    const canvas = await html2canvas(element, {
      backgroundColor: '#ffffff',
      scale: 2,
      useCORS: true,
      allowTaint: true,
      logging: false,
      width: element.offsetWidth,
      height: element.offsetHeight,
      imageTimeout: 0,
      removeContainer: true,
      foreignObjectRendering: false,
      // Configurações adicionais para melhor renderização
      ignoreElements: (element) => {
        // Ignorar elementos que podem causar problemas
        const htmlElement = element as HTMLElement
        return element.classList.contains('ignore-capture') || htmlElement.style.display === 'none' || htmlElement.style.visibility === 'hidden'
      },
    })

    // Converter para blob e baixar
    canvas.toBlob(
      (blob) => {
        if (blob) {
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = config.name
          link.click()
          URL.revokeObjectURL(link.href)
        }
      },
      'image/png',
      0.95,
    )
  } catch {
    alert('Não foi possível capturar a área selecionada. Verifique se o elemento está visível na tela.')
  }
}
